export default __webpack_public_path__ + "static/media/video-album.84690800.png";